import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const GroupItem = () => {
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_MAIN_SITE_URL}/group-sets`);
                setGroups(res.data.data);
            } catch (error) {
                console.error('Failed to fetch groups:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchGroups();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            {groups.map((group, index) => (
                <div className="col-xl-6 col-12" key={index}>
                    <div className="group-item lab-item">
                        <div className="lab-inner d-flex flex-wrap align-items-center p-4">
                            <div className="lab-thumb me-sm-4 mb-4 mb-sm-0">
                                <img 
                                    src={group.image} 
                                    alt={group.name} 
                                    className="rounded" 
                                    width="100"
                                />
                            </div>
                            <div className="lab-content">
                                <h4>{group.name}</h4>
                                <p>{group.description}</p>
                                <ul className="img-stack d-flex">
                                    {group.members.map((member, i) => (
                                        <li key={i}>
                                            <img 
                                                src={member.imgUrl} 
                                                alt={member.name} 
                                                className="rounded-circle inherit-img-height" 
                                                width="40"
                                            
                                            />
                                        </li>
                                    ))}
                                    {group.moreCount && (
                                        <li className="bg-theme d-flex align-items-center justify-content-center text-white rounded-circle" style={{ width: '40px', height: '40px' }}>
                                            {group.moreCount}
                                        </li>
                                    )}
                                </ul>
                                <div className="mt-2">
                                    <Link to="/community" className="lab-btn">
                                        <i className="icofont-users-alt-5"></i> View More
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default GroupItem;
